import RenderManager from "sap/ui/core/RenderManager";
import Control from "sap/ui/core/Control";

interface InfoLabelControl extends Control {
  getFontColor(): string;

  getBorderColor(): string | null;

  getBackgroundColor(): string;

  getText(): string;
}

export default {
  apiVersion: 2,
  render(oRm: RenderManager, oControl: InfoLabelControl): void {
    const sTextColor = oControl.getTextColor();
    const sBackgroundColor = oControl.getBackgroundColor();

    oRm.openStart("span", oControl);
    oRm.class("sapMInfoLabel");
    oRm.class("cursorPointer");
    oRm.style("background-color", sBackgroundColor);
    oRm.style("color", sTextColor);
    oRm.style("border", `1px solid ${sTextColor}`);
    oRm.style("padding", "0.25rem 0.5rem");
    oRm.style("border-radius", "0.5rem");
    oRm.style("font-weight", "bold");
    oRm.style("font-size", "0.875rem");
    oRm.style("display", "inline-block");
    oRm.style("text-align", "center");
    oRm.style("line-height", "1.2rem");
    oRm.openEnd();

    oRm.text(oControl.getText());

    oRm.close("span");
  },
};